import React, { useEffect } from 'react';

import useGlobal from '../../../store';
import FormControl from '../../../facturotopia/FormControl';
import LoadingButton from '../../../facturotopia/LoadingButton';
import { TheError, TheResult } from '../../../shared/responses/TheResult';

const mapState = (store) => {
  return {
    hits: store.admin.clientes.hits,
    info: store.admin.clientes.info,
  };
};

const mapActions = (actions) => {
  return {
    hits: actions.admin.clientes.hits,
    info: actions.admin.clientes.info,
  };
};

const ClienteAssignacionHits = ({ data: cliente = {} }) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { busy, data, result, error } = state.hits;

  const handleOnChange = (value) => {
    actions.hits.change(value);
  };

  const handleOnSubmit = (value) => {
    actions.hits.submit();
    actions.info.setPartialState({
      data: {
        ...state.info.data,
        hits: (parseInt(state.info.data.hits) || 0) + (parseInt(data.hits) || 0),
      },
    });
  };

  useEffect(() => {
    actions.hits.change({
      cliente_id: cliente.id,
    });
  }, [cliente.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const hits = parseInt(data.hits) || 0;

  return (
    <div>
      <div className="row">
        <div className="col-sm-5">
          <FormControl
            type="number"
            label="Asignar hits"
            name="hits"
            placeholder=""
            help=""
            min="0"
            step="1"
            autoComplete="off"
            value={data.hits || ''}
            onChange={handleOnChange}
          />
        </div>
        <div className="col-sm-5">
          <FormControl
            type="select"
            label="Estrategia"
            name="estrategia"
            placeholder=""
            help=""
            value={data.estrategia}
            options={[
              { label: 'adicionales', value: '' },
              { label: 'fijo', value: 'fijo' },
            ]}
            onChange={handleOnChange}
          />
        </div>
      </div>

      {!!result && <TheResult result={result} />}

      {!!error && <TheError error={error} />}

      <div className="row">
        <div className="col">
          <LoadingButton
            type="button"
            disabled={busy || hits <= 0}
            loading={busy || false}
            onClick={handleOnSubmit}
          >
            {busy ? 'Guardando...' : 'Guardar'}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default ClienteAssignacionHits;
